module.exports = __webpack_public_path__ + "static/media/solar-panel.b4d0c278.svg";